import type { FC } from "react";

import { t } from "i18n/i18n";
import { Listbox, type ListboxEntry } from "mds/components/Listbox";
import { type SquareButtonProps } from "mds/components/buttons/SquareButton";

const INDEFINITE_ID = "infinity";

type IntervalOption = { id: string; title: string; value: number };

const INTERVAL_ITEMS: Array<ListboxEntry<IntervalOption>> = [
  {
    id: INDEFINITE_ID,
    title: t("timedelta.indefinite"),
    value: Infinity,
  },
  { type: "divider" },
  ...[1, 2, 3, 4, 5, 6, 7].map((days) => ({
    id: String(days),
    title: t("timedelta.days", { count: days }),
    value: days,
  })),
];

interface LateSubmissionIntervalDropdownProps {
  value: number;
  className?: string;
  onChange: (value: number) => void;
  disabled?: boolean;
  size?: SquareButtonProps<"button">["size"];
  id?: string;
  "aria-invalid"?: boolean;
  "aria-describedby"?: string;
  "aria-required"?: boolean;
}

export const LateSubmissionIntervalDropdown: FC<LateSubmissionIntervalDropdownProps> = ({
  value,
  onChange,
  className,
  disabled = false,
  size = "xs",
  id,
  "aria-invalid": ariaInvalid,
  "aria-describedby": ariaDescribedBy,
  "aria-required": ariaRequired,
}) => {
  const selectedValue = value === Infinity ? INDEFINITE_ID : String(value);

  return (
    <Listbox
      aria-describedby={ariaDescribedBy}
      aria-invalid={ariaInvalid}
      aria-required={ariaRequired}
      buttonSize={size}
      className={className}
      disabled={disabled}
      id={id}
      items={INTERVAL_ITEMS}
      selectedValue={selectedValue}
      onSelectionChange={(item) => onChange(item.value)}
    />
  );
};
